<template>
  <header class="c_cs_header">
    <div class="c_wrapper">
      <div class="c_cs_header__leading_text">
        <h4 class="c_2022--body" v-if="eyebrow">{{ eyebrow }}</h4>
        <h1 class="c_2022--h1_schnyder" v-if="title">{{ title }}</h1>
        <p class="c_2022--lead" v-if="leadParagraph">{{ leadParagraph }}</p>
      </div>
      <div
        class="c_cs_header__details"
        v-if="detailsTable"
        :class="{ 'c_cs_header__details--multi': detailsTable.length > 0 }"
      >
        <div class="c_chart__item" v-for="(column, index) in detailsTable" :key="index">
          <h4 class="c_2022--body" v-if="column.detailTitle">{{ column.detailTitle }}</h4>
          <div class="c_2022--body" v-if="column.detailDescription" v-html="column.detailDescription"></div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    eyebrow: String,
    title: String,
    leadParagraph: String,
    detailsTable: Array,
  },
};
</script>

<style lang="scss">
.c_cs_header {
  $self: &;

  background-color: $color_black;
  color: $color_white;
  padding-top: px_to_rem(40);
  padding-bottom: px_to_rem(40);
  h4 {
    @include font('graphik_medium');
    color: $color_yellow;
  }
  h1 {
    @include font('schnyder_wide_l_light');
    padding: px_to_rem(34) 0 px_to_rem(41);
    @include mq($mq_sm_to_md) {
      padding: px_to_rem(42) 0 px_to_rem(48);
    }
  }
  p {
    @include font('graphik_regular');
  }
  @at-root #{&}__leading_text {
    text-align: center;
  }
  @at-root #{&}__details {
    margin-top: px_to_rem(40);
    @include mq($mq_md_to_lg) {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      border-left: 1px solid $color_gray_112;
    }
    h4 {
      @include font('graphik_bold');
    }
    ul {
      padding-left: px_to_rem(20);
      li {
        list-style-type: disc;
      }
    }
    ol {
      padding-left: px_to_rem(20);
      li {
        list-style-type: decimal;
      }
    }
    a,
    a:visited {
      color: $color_red;
      &:hover {
        text-decoration: none;
      }
    }
    @at-root #{&}--multi {
      & > div {
        padding: px_to_rem(10) px_to_rem(0) px_to_rem(10);
        @include mq($mq_md_to_lg) {
          padding: px_to_rem(60) px_to_rem(32) px_to_rem(40);
          border-right: px_to_rem(1) solid $color_gray_112;
        }
      }
    }
  }
}
</style>
